import { render, staticRenderFns } from "./LogsSummary.vue?vue&type=template&id=123bf458"
import script from "./LogsSummary.vue?vue&type=script&lang=js"
export * from "./LogsSummary.vue?vue&type=script&lang=js"
import style0 from "./LogsSummary.vue?vue&type=style&index=0&id=123bf458&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports